import { useState } from 'react';
import { api, ErrorApi, mensajeError } from '@/api/cliente';
import { Button } from '@/components/ui/button';
import { Campo, Input } from '@/components/ui/form';
import { Dialogo } from '@/components/ui/overlay';

interface Props {
  motivo: string;
  /** Operación concreta que se autoriza (el token no sirve para otra). */
  accion: 'desbloqueo_caja' | 'cambio_margen';
  onAutorizado: (token: string) => void;
  onCerrar: () => void;
  /** Si se indica, ofrece mandar la solicitud al teléfono del dueño en lugar de la contraseña. */
  onEnviarAlDueno?: () => void;
}

/** Pide usuario y contraseña del dueño presente y devuelve un token de autorización de un solo uso. */
export function AutorizacionDueno({ motivo, accion, onAutorizado, onCerrar, onEnviarAlDueno }: Props) {
  const [usuario, setUsuario] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  const autorizar = async () => {
    setEnviando(true);
    setError(null);
    try {
      const { autorizacionToken } = await api<{ autorizacionToken: string }>('/auth/verificar-dueno', { method: 'POST', body: { usuario, password, motivo, accion } });
      onAutorizado(autorizacionToken);
    } catch (e) {
      setError(e instanceof ErrorApi && e.status === 401 ? 'Usuario o contraseña del dueño incorrectos' : mensajeError(e));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Dialogo
      abierto
      ancho="sm"
      onCambiarAbierto={(v) => !v && onCerrar()}
      titulo="Autorización del dueño"
      descripcion={motivo}
      pie={
        <>
          {onEnviarAlDueno && (
            <Button variante="secundario" onClick={onEnviarAlDueno}>
              Enviar al dueño
            </Button>
          )}
          <Button onClick={() => void autorizar()} cargando={enviando} disabled={!usuario || !password}>
            Autorizar
          </Button>
        </>
      }
    >
      <div className="grid gap-3">
        {onEnviarAlDueno && <p className="text-[13px] text-foreground-muted">¿El dueño no está? Envíale la solicitud; la aprobará desde su teléfono.</p>}
        <Campo etiqueta="Usuario del dueño">{(p) => <Input {...p} value={usuario} onChange={(e) => setUsuario(e.target.value)} autoComplete="off" autoFocus />}</Campo>
        <Campo etiqueta="Contraseña" error={error ?? undefined}>
          {(p) => <Input {...p} type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="off" onKeyDown={(e) => e.key === 'Enter' && void autorizar()} />}
        </Campo>
      </div>
    </Dialogo>
  );
}
